module.exports = __webpack_public_path__ + "static/img/logo-vue-material-default.fa8ffa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vue-material-default.png
// module id = 408
// module chunks = 83